
import { toast } from "react-toastify";
export const handleError = (dispatch, error, setError, page, hideNotif = false) => {
    if (error?.response?.data) {
        dispatch(setError({ ...error?.response?.data, page, status: error?.response?.status }))
        if (error?.response?.status === 401) {
            const regex = /\/blogs\/.*/gm;
            if (!['/', '/contact', '/catalogs', '/blogs'].includes(window.location.pathname) && !regex.test(window.location.pathname)) {
                window.location.replace('/get-code')
            }
        }
        if (error?.response?.status === 404) {
            if (!['/'].includes(window.location.pathname)) {
                window.location.replace('/')
            }
        }
    } else {
        dispatch(setError({ message: 'An error occurred!', error: {}, page }))
    }
    if (!hideNotif)
        toast.warning("خطایی رخ داده است!", { autoClose: 5000 })
}

export const convertToFormData = (body = {}) => {
    let form = new FormData()
    for (const property in body) {
        if (Array.isArray(body[property])) {
            body[property].forEach(item => {
                form.append(`${property}[]`, item)
            })
        }
        else {
            form.append(property, body[property])
        }
    }
    return form
}